import {Model} from "@/app/Model";

export class ResponsabilitaDashboardFlow {

    public durata_procedimento_active: boolean = false;
    public durata_procedimento: number = 0;
    public durata_procedimento_notNull: boolean = false;

    public riferimento_normativo: string = "";
    public tipologia_danno: string = "";
    public tipologia_danno_patrimoniale: string = "";
    public tipologia_danno_non_patrimoniale: string = "";

    public domanda_accolta:string = "";
    public risarcimento:string = "";
    public risarcimento_richiesto_active: boolean = false;
    public risarcimento_richiesto_min: number = Model.lista_importi_minMax[0];
    public risarcimento_richiesto_max: number = Model.lista_importi_minMax[1];
    public risarcimento_richiesto_da: number = Model.lista_importi_minMax[0];
    public risarcimento_richiesto_a: number = Model.lista_importi_minMax[1];
    public risarcimento_disposto_totale_active: boolean = false;
    public risarcimento_disposto_totale_min: number = Model.lista_importi_minMax[0];
    public risarcimento_disposto_totale_max: number = Model.lista_importi_minMax[1];
    public risarcimento_disposto_totale_da: number = Model.lista_importi_minMax[0];
    public risarcimento_disposto_totale_a: number = Model.lista_importi_minMax[1];

    public id_localita: string = "";
    public giudice: string = "";

    public data_active: boolean = false;
    public data_min: number = Model.lista_anno_minMax[0];
    public data_max: number = Model.lista_anno_minMax[1];
    public data_da: number = Model.lista_anno_minMax[0];
    public data_a: number = Model.lista_anno_minMax[1];

    //---
    public paginazione_tot: number = 0;
    public paginazione_start: number = 0;
    public paginazione_rows: number = Model.pagination_size;
    public paginazione_pages: number = 0;

    public diritto_paginazione_tot: number = 0;
    public diritto_paginazione_start: number = 0; //numero di pagina
    public diritto_paginazione_rows: number = Model.pagination_size;
    public diritto_paginazione_pages: number = 0;

    public reset(): void {
        this.durata_procedimento_active = false;
        this.durata_procedimento = 0;
        this.durata_procedimento_notNull = false;

        this.riferimento_normativo = "";
        this.tipologia_danno = "";
        this.tipologia_danno_patrimoniale = "";
        this.tipologia_danno_non_patrimoniale = "";

        this.domanda_accolta = "";
        this.risarcimento = "";
        this.risarcimento_richiesto_active = false;
        //this.risarcimento_richiesto_min = Model.lista_importi_minMax[0];
        //this.risarcimento_richiesto_max = Model.lista_importi_minMax[1];
        this.risarcimento_richiesto_da = Model.lista_importi_minMax[0];
        this.risarcimento_richiesto_a = Model.lista_importi_minMax[1];
        this.risarcimento_disposto_totale_active = false;
        //this.risarcimento_disposto_totale_min = Model.lista_importi_minMax[0];
        //this.risarcimento_disposto_totale_max = Model.lista_importi_minMax[1];
        this.risarcimento_disposto_totale_da = Model.lista_importi_minMax[0];
        this.risarcimento_disposto_totale_a = Model.lista_importi_minMax[1];

        this.id_localita = "";
        this.giudice = "";

        this.data_active = false;
        this.data_da = this.data_min;
        this.data_a = this.data_max;

        //---
        this.paginazione_tot = 0;
        this.paginazione_start = 0;
        this.paginazione_rows = Model.pagination_size;
        this.paginazione_pages = 0;

        this.diritto_paginazione_tot = 0;
        this.diritto_paginazione_start = 0;
        this.diritto_paginazione_rows = Model.pagination_size;
        this.diritto_paginazione_pages = 0;
    }
}